<template>
    <div class="content" id="content">

    <toolbar v-bind:selection="toolbar" v-bind:title="'Reina '+info.name" action="eliminar" />

    <div v-if="!info.id">
        <div class="card mb-3" style="padding:50px 50px 50px 50px; text-align:center">
            <p>Reina <b>no encontada</b> o no está disponible en este momento.</p>
            <a href="#/queens">Volver a ver reinas</a>
        </div>
    </div>

    <div v-else>

        <v-tabs>
            <v-tabs-slider color="orange"></v-tabs-slider>

            <v-tab @click="tabs.tab1 = true; tabs.tab2 = false">HISTORIAL ({{infocycles.length}})</v-tab>
            <v-tab @click="tabs.tab1 = false; tabs.tab2 = true">Detalle</v-tab>
        </v-tabs>

        <div v-if="tabs.tab1===true">
            <ul v-if="infocycles.length>0">
                <li class="card" v-for="cycles in infocycles" :key="cycles.id" v-bind:id="'cycles'+cycles.id">
                    <div class="info-item">

                        <div class="info-item-list-left">


                            <span v-if="cycles.date!=''" class="badge">{{ cycles.date.split("-").reverse().join('-') }}</span>&nbsp;
                            <span v-if="cycles.state" class="let"><b>{{ cycles.state }}</b></span>
                            <p style="padding-top:5px;" v-if="cycles.cycle" class="let">Ciclo: {{ cycles.cycle }}</p>
                            <p style="padding-top:5px;" v-if="cycles.idcolmenar">Colmena: {{ cycles.number }} en {{cycles.namecolmenar}}</p>

                        </div>

                        <div class="info-item-list-right">

                            <a v-bind:href="'#/ciclo-reina-editar/' + cycles.id">
                                <v-icon color="grey">mdi-chevron-right</v-icon>
                            </a>

                        </div>
                    </div>
                </li>
            </ul>



            <div v-else class="card">
                <div style="padding:20px; text-align:center">
                    Reina sin ciclos
                </div>
                <div v-if="info.date_archived===null">
                    <router-link v-bind:to="'../ciclo-reina-nueva/'+info.id" class="btn btn-yellow">
                        Añadir ciclo
                    </router-link>
                </div>
            </div>

        </div>

        <div v-if="tabs.tab2===true" class="card">

            <div class="row">
                <div class="col-d-10">
                    <p class="title-box"> Reina {{info.name}}</p>
                </div>
                <div class="col-d-2">
                    <span v-bind:class="'badge badge-'+info.color">{{ info.year }}</span>
                </div>
            </div>
            <div class="info-item">
                <div>
                    <infoqueen
                            v-bind:description="info.description"
                            v-bind:race="info.race"
                            v-bind:origin="info.origin"
                    ></infoqueen>

                    <p v-if="info.color==='sin marcar'" class="text-red">Sin marcar</p>
                    <p v-if="info.number"><v-icon>mdi-map-marker</v-icon>&nbsp;

                        <b>Colmena</b> {{info.number}} en <b>colmenar</b> {{info.namecolmenar}}</p>

                    <div v-if="info.date_archived!=null">
                        <p><b>Fecha archivada:</b> {{info.date_archived}}</p>
                    </div>

                </div>
            </div>




        </div>
    </div>

    <menubottom active="2" />

</div>

</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import menubottom from "@/components/MenuBottom"

import infoqueen from "@/components/queens/infoqueen"
import lastcyclequeen from "@/components/queens/lastcyclequeen"

import axios from "axios";
/*import Datepicker from 'vuejs-datepicker';*/

export default {

    name: 'queen-detalle',
    components: {toolbar,menubottom,infoqueen,lastcyclequeen},
    data() {
      return {

        tabs: {
            tab1: true,
            tab2: false,
        },
        toolbar: {
            return: '1',
            icons: [
              { text: 'Editar reina', href:'queen-editar/'+this.$route.params.id },
              { text: 'Eliminar reina', click:'delete', id:this.$route.params.id, method:'queens' },
              { text: 'Nuevo ciclo', href:'ciclo-reina-nueva/'+this.$route.params.id },
              { text: 'Cancelar', href:'queen-detalle/'+this.$route.params.id }
            ],
          },
        info: null,
        infocycles: null
      }
    },
  created() {
    auth.getUserLogged()

    var that = this
    axios.get("https://appws.panimiel.com/new/index.php/api/queens/detail/"+this.$route.params.id).then((info) => {
      that.info = info.data
    })

    axios.get("https://appws.panimiel.com/new/index.php/api/queens_cycle/"+this.$route.params.id).then((infocycles) => {
      that.infocycles = infocycles.data
    })

  }
};

</script>

<style scoped lang="scss">
</style>